<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">INVERSIONES, CUENTAS BANCARIAS Y OTRO TIPO DE VALORES / ACTIVOS (SITUACIÓN ACTUAL)</legend>
        </div>
      </div>
      <div class="form-group col-6">
        <label class="control-label"> ¿ Tiene inversiones ? <b-button class="btn-popover" v-b-popover.hover.top="info.inversiones"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de las inversiones, cuentas bancarias y otro tipo de valores / activos a nombre la pareja, dependientes económicos y/o terceros o que sean en copropiedad con el declarante no serán públicos. </div>
        </div>
        <div class="row">
          <legend>Inversiones, cuentas bancarias y otro tipo de valores del declarante, pareja y/o dependientes económicos </legend>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="control-label">Tipo de Inversión <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_inversion"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="tipo_inversion" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.tipo_inversion_id">
              <el-option v-for="option in inversiones" class="select-default" :value="option.id" :label="option.valor" :key="option.valor"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo_inversion')}}</small>
          </div>

          <!-- <div class="form-group col-6" v-if=" form_item.tipo_inversion_id == 7" key="v_inversion_esp">
            <label class="control-label">Especificar tipo inversión</label>
            <input name="tipo_inversion_especifica" v-validate="'required|min:1'" class="form-control" type="text" v-model="form_item.tipo_inversion_especificar" placeholder="Especificar">
            <small class="text-danger">{{ errors.first('tipo_inversion_especifica')}}</small>
          </div> -->
          <div class="form-group col-6">
            <label class="control-label">Titular de la inversion, cuentas bancarias y otro tipo de valores <b-button class="btn-popover" v-b-popover.hover.top="info.titular"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable class="select-default" placeholder="Seleccione una opción" name="titular_id" v-validate="'required'" v-model="form_item.titular_id">
              <el-option v-for="option in titular_adeudo" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('titular_id')}}</small>
          </div>

          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">Tercero <b-button class="btn-popover" v-b-popover.hover.top="info.tercero"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="tercero" class="d-inline-block" v-validate="'required'" v-model="form_item.tercero" label="1">Persona física</p-radio>
            <p-radio name="tercero" class="d-inline-block" v-validate="'required'" v-model="form_item.tercero" label="2">Persona moral</p-radio>
            <br><small class="text-danger">{{ errors.first('tercero')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">Nombre del tercero o terceros <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_tercero"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_tercero" v-validate="'required'" v-model="form_item.nombre_tercero" placeholder="Nombre o razón social">
            <small class="text-danger">{{ errors.first('nombre_tercero')}}</small>
          </div>
          <div class="form-group col-6" v-if="terceros">
            <label class="control-label">RFC del tercero <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_tercero"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_tercero" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc_tercero" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc_tercero')}}</small>
          </div>


          <!-- COndicionales de la primera respuesta -->
          <div class="form-group col-6" v-if="form_item.tipo_inversion_id == 1">
            <label class="control-label">Bancaria <b-button class="btn-popover" v-b-popover.hover.top="info.bancaria"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="bancaria" v-validate="'required|min:1'" filterable class="select-default" placeholder="Bancaria" v-model="form_item.bancaria_id">
              <el-option v-for="option in inv_bancarias" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('bancaria')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_inversion_id == 3">
            <label class="control-label">Fondos de inversión <b-button class="btn-popover" v-b-popover.hover.top="info.fondo"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="fondo_inversion_id" v-validate="'required|min:1'" filterable class="select-default" placeholder="Fondo de Inversión" v-model="form_item.fondo_inversion_id">
              <el-option v-for="option in inv_fondos" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('fondo_inversion_id')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_inversion_id == 4">
            <label class="control-label">Organizaciones privadas y/o mercantiles <b-button class="btn-popover" v-b-popover.hover.top="info.organizaciones"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="organizacionespym_id" v-validate="'required|min:1'" filterable class="select-default" placeholder="Organizaciones privadas y/o mercantiles" v-model="form_item.organizacionespym_id">
              <el-option v-for="option in inv_organizaciones" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('organizacionespym_id')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_inversion_id == 5">
            <label class="control-label">Posesión de monedas y/o metales <b-button class="btn-popover" v-b-popover.hover.top="info.monedas_metales"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="moneda_metales_id" v-validate="'required|min:1'" filterable class="select-default" placeholder="Posesión de monedas y/o metales" v-model="form_item.moneda_metales_id">
              <el-option v-for="option in inv_monedas" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('moneda_metales_id')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_inversion_id == 6">
            <label class="control-label">Seguros <b-button class="btn-popover" v-b-popover.hover.top="info.seguros"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="seguro_id" v-validate="'required|min:1'" filterable class="select-default" placeholder="Seguros" v-model="form_item.seguro_id">
              <el-option v-for="option in inv_seguros" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('seguro_id')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_inversion_id == 2">
            <label class="control-label">Valores bursátiles <b-button class="btn-popover" v-b-popover.hover.top="info.valores"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="valores_id" v-validate="'required|min:1'" filterable class="select-default" placeholder="Valores bursátiles" v-model="form_item.valores_id">
              <el-option v-for="option in inv_valores" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('valores_id')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_inversion_id == 7">
            <label class="control-label">Afores y otros <b-button class="btn-popover" v-b-popover.hover.top="info.afores"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="afore_id" v-validate="'required|min:1'" filterable class="select-default" placeholder="Afores y otros" v-model="form_item.afore_id">
              <el-option v-for="option in inv_afores" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('afore_id')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Número de cuenta, contrato o póliza <b-button class="btn-popover" v-b-popover.hover.top="info.cuenta"><i class="far fa-question-circle"></i></b-button></label>
            <input name="numero_cuenta" v-validate="'required|min:1'" class="form-control" type="text" v-model="form_item.numero_cuenta" placeholder="Especificar">
            <small class="text-danger">{{ errors.first('numero_cuenta')}}</small>
          </div>

          <div class="form-group col-6 ">
            <label class="control-label">Saldo a la fecha (Situación actual) <b-button class="btn-popover" v-b-popover.hover.top="info.monto_original+' '+info.moneda_id"><i class="far fa-question-circle"></i></b-button></label>
            <div class="customCurrency">
              <b-input-group size="sm" :prepend="getSigno">
                <b-form-input name="monto_original" v-validate="'required|min:1'" type="number" min="0" class="text-right" v-model="form_item.monto_original" placeholder="0" @keyup.native="isNumber" />
                <!-- @keyup.native="isNumber($event,form_item.monto_original)" -->
                <b-dropdown right split :text="getCodigoMoneda" v-model="form_item.moneda_id">
                  <b-dropdown-item v-for="option in monedas" :key="option.codigo" :value="option.codigo" @click="form_item.moneda_id = option.id">{{option.moneda}}</b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </div>
            <small class="text-danger">{{ errors.first('monto_original')}}</small>
          </div>


          <legend>¿Donde se localiza la inversion, cuentas bancarias y otro tipo de valores? <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button>
          </legend>

          <!--        <div class="form-group col-6">
            <label class="control-label"> <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="nacional_extranjero" class="d-inline-block" v-validate="'required'" v-model="form_item.nacional_extranjero" label="1">México</p-radio>
            <p-radio name="nacional_extranjero" class="d-inline-block" v-validate="'required'" v-model="form_item.nacional_extranjero" label="2">Extranjero</p-radio>
            <br><small class="text-danger">{{ errors.first('nacional_extranjero')}}</small>
          </div> -->

          <div class="form-group col-6">
            <label class="control-label"> País </label>
            <el-select clearable name="pais" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="form_item.domicilio_institucion_pais_id">
              <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('pais') }}</small>
          </div>

          <div class="form-group col-6">
            <label class="control-label">Institución o razón social <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_institucion"><i class="far fa-question-circle"></i></b-button></label>
            <input name="nombre_institucion" v-validate="'required|min:1'" class="form-control" type="text" v-model="form_item.nombre_institucion" placeholder="Nombre de la institución">
            <small class="text-danger">{{ errors.first('nombre_institucion')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.domicilio_institucion_pais_id==150">
            <label class="control-label">RFC de la institución <b-button class="btn-popover" v-b-popover.hover.top="info.frc_institucion"><i class="far fa-question-circle"></i></b-button></label>
            <input name="rfc_institucion" v-validate="'required|min:1'" class="form-control" type="text" v-model="form_item.rfc_institucion" placeholder="RFC de la institución">
            <small class="text-danger">{{ errors.first('rfc_institucion')}}</small>
          </div>



          <div class="form-group col-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="!edit_item ">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.titular_id="{ item }">
                <div>{{filterCatalog(item.titular_id,titular_adeudo)}}</div>
              </template>
              <template v-slot:item.tipo_inversion_id="{ item }">
                <div>{{filterCatalog(item.tipo_inversion_id,inversiones)}}</div>
              </template>

            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],
    data() {
      return {
        ip_id: 1,
        add_item: false,
        edit_item: null,
        bandera: '0',
        table_list: [],
        form_item: {},
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Tipo de Inversión',
          value: 'tipo_inversion_id',
          align: 'center',
        }, {
          text: 'Titular',
          value: 'titular_id',
          align: 'center',
        }, {
          text: 'Número de cuenta, contrato o póliza',
          value: 'numero_cuenta',
          align: 'center',
        }, {
          text: 'Institución o razón social',
          value: 'nombre_institucion',
          align: 'center',
        }, ],
        info: {
          inversiones: 'Para la declaración de inicio reportar la situación de las inversiones, cuentas bancarias y otro tipo de valores a la fecha de ingreso al empleo, cargo o comisión. Para la declaración de modificación reportar la situación de las inversiones, cuentas bancarias y otro tipo de valores del año inmediato anterior. Para la declaración de conclusión reportar la situación de las inversiones, cuentas bancarias y otro tipo de valores a la fecha de conclusión del empleo, cargo o comisión. El Declarante reportara toda la información relacionada con sus inversiones, cuentas bancarias o algún otro tipo de valor que forme parte de sus activos.',
          tipo_inversion: 'Elegir del catálogo la inversión, la cuenta o el valor a reportar, dependiendo la elección deberá señalar número de cuenta, número de contrato o número de póliza.',
          titular: 'Seleccionar alguna de las opciones del catálogo desplegable.',
          tercero: 'En caso de copropiedad con un tercero, seleccionar si es persona física o persona moral.',
          nombre_tercero: 'En caso de señalar copropiedad, escribir el nombre o nombres completos, así como apellidos completos sin abreviaturas y sin acentos ni signos especiales. Si se trata de persona moral deberá proporcionar la denominación o razón social de la institución tal y como se encuentra en el documento con el que se acredita la adquisición.',
          rfc_tercero: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos.',
          bancaria: 'Seleccionar cualquiera de las siguientes opciones: cuenta de nómina, cuenta de ahorro, cuenta de cheques, cuenta maestra, cuenta eje y depósito a plazos.',
          fondo: 'Seleccionar cualquiera de las siguientes opciones: sociedades de inversión, inversiones financieras en el extranjero.',
          organizaciones: 'Seleccionar cualquiera de las siguientes opciones: acciones o cajas de ahorro.',
          monedas_metales: 'Seleccionar cualquiera de las siguientes opciones: centenarios, divisas, moneda nacional, onzas troy, criptomonedas.',
          seguros: 'Seleccionar cualquiera de las siguientes opciones: seguro de separación individualizado, seguro de inversión y seguro de vida.',
          valores: 'Seleccionar cualquiera de las siguientes opciones: acciones y derivados, aceptaciones bancarias, bonos gubernamentales, papel comercial.',
          afores: 'Seleccionar cualquiera de las siguientes opciones: afores, fideicomisos, certificados de la tesorería, préstamos a favor de un tercero.',
          nombre_institucion: 'Señalar el nombre de la institución donde se encuentran registradas las inversiones cuentas o valores.',
          frc_institucion: 'Señalar los doce dígitos correspondientes. (Si aplica).',
          cuenta: 'Señalar el número de cuenta, contrato, póliza o cualquier dato que permita su identificación.',
          monto_original: 'Es necesario capturar cantidades sin comas, sin puntos, sin centavos y sin ceros a la izquierda.',
          moneda_id: 'Deberá seleccionar la moneda relativa a la cuenta.',
          lugar: 'Indicar si se encuentra en México o en el extranjero, debiendo señalar el país donde se localiza.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },
    computed: {
      terceros() {
        if (this.form_item) {
          if (this.form_item.titular_id) {
            var arr = [3, 4, 5, 8, 10, 13, 15, 18, 19, 24, 25];
            return arr.includes(this.form_item.titular_id);
          }
        }
        return false;
      },
      getSigno() {
        var signo = "$";
        var val = this.form_item.moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },
      getCodigoMoneda() {
        var codigo = "MXN";
        var val = this.form_item.moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            codigo = item.codigo;
          }
        });
        return codigo;
      },

    },
    watch: {

    },
    methods: {

      showItem() {
        this.add_item = true;
        if (!this.form_item.domicilio_institucion_pais_id) {
          //El id Mexico es 150
          this.form_item.domicilio_institucion_pais_id = 150;

        }
        this.form_item.moneda_id = 97;
        this.$validator.resume();
      },
      cancelEdit() {
        this.add_item = false;
        this.form_item = {};
        this.edit_item = false;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              //this.checkDomicilio();
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("inversiones_cuentas_valores", this.form_item).then(
                response => {
                  this.StepOk("Guardado");
                  //if (this.edit_item === undefined || this.edit_item === null) {
                  if (!this.edit_item) {
                    this.table_list.unshift({
                      ...response.data.response
                    });
                  } else {
                    let index = this.table_list.map(u => {
                      return u.id;
                    }).indexOf(response.data.response.id);
                    this.table_list.splice(index, 1, response.data.response);
                  }
                  this.cancelEdit();
                }, error => {
                  this.StepError(error);
                });
            }
          } else {
            this.StepW("Hay campos sin completar");
            this.scrolling();
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = true;
        this.form_item = {
          ...item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("inversiones_cuentas_valores/" + item.id).then(
              response => {
                let index = this.table_list.map(u => {
                  return u.id;
                }).indexOf(item.id);
                this.table_list.splice(index, 1);
                this.StepOk('Registro eliminado');
              }, error => {
                this.Err(error);
              });
          });
        }
      },
      checkDomicilio() {
        if (this.n_domicilio) {
          this.form_item.domicilio_institucion_pais_id = this.n_domicilio.pais;
          this.form_item.entidad_federativa_id = this.n_domicilio.entidadF;
          this.form_item.municipio_id = this.n_domicilio.municipio;
          this.form_item.localidad_id = this.n_domicilio.localidad;
          this.form_item.cp = this.n_domicilio.cp;
          this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre;
          this.form_item.vialidad_tipo = this.n_domicilio.vialidad;
          this.form_item.numext = this.n_domicilio.ext;
          this.form_item.numint = this.n_domicilio.int;
          this.form_item.colonia = this.n_domicilio.colonia;
        }
      },

    },
    created() {
      this.ip_id = this.getKey('uid');
      this.$http.get("inversiones_cuentas_valores/" + this.ip_id).then(
        response => {
          this.table_list = response.data.response;
          if (this.table_list) {
            if (this.table_list.length > 0) {
              this.bandera = '1';
            }
          }
        });
    },
    mounted() {
      this.checkCatalogs();
      this.form_item.domicilio_institucion_pais_id = 150;
    },
  };

</script>
<style>
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
    -moz-appearance: textfield !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Activos/Inversiones.vue